// extracted by mini-css-extract-plugin
export var labelWrapper = "_gm-0";